import React, { useRef, useState, useEffect } from 'react'
import {Icon, IconName} from "./Icon"
import './CopyButton.less'

export interface MenuItem {
  id: string
  title: string
}

interface CopyButtonProps {
  onCopy: (itemId?: string) => void | Promise<void>
  tooltipText?: string
  className?: string
  ariaLabel?: string
  menuItems?: MenuItem[]
}

export const CopyButton: React.FC<CopyButtonProps> = ({
  onCopy,
  tooltipText = 'Copy',
  className = '',
  ariaLabel = 'Copy',
  menuItems
}) => {
  const [showMenu, setShowMenu] = useState(false)
  const buttonRef = useRef<HTMLButtonElement>(null)
  const menuRef = useRef<HTMLDivElement>(null)

  const handleClick = async (itemId?: string) => {
    await onCopy(itemId)
    if (menuItems) {
      setShowMenu(false)
    }
  }

  const handleButtonClick = () => {
    if (menuItems && menuItems.length > 0) {
      setShowMenu(!showMenu)
    } else {
      handleClick()
    }
  }

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node) &&
          buttonRef.current && !buttonRef.current.contains(event.target as Node)) {
        setShowMenu(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <div className={`copy-button-container ${className}`} ref={menuRef}>
      <button
        ref={buttonRef}
        className={`copy-button ${showMenu ? 'active' : ''}`}
        onClick={handleButtonClick}
        aria-label={ariaLabel}
        aria-haspopup={menuItems ? "true" : undefined}
        aria-expanded={showMenu ? "true" : undefined}
        title={tooltipText}
      >
        <Icon
          name={IconName.Copy}
          className="copy-icon"
          width="20"
          height="20"
        />
      </button>

      {showMenu && menuItems && menuItems.length > 0 && (
        <div className="copy-menu">
          <ul className="copy-menu-list">
            {menuItems.map((item) => (
              <li
                key={item.id}
                className="copy-menu-item"
                onClick={() => handleClick(item.id)}
              >
                {item.title}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}
